import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePDFAuth } from "../contexts/PDFAuthContext";

/**
 * ResumeRedirect component
 * This page redirects visitors from /me to the home page
 * Automatically authenticates PDF access for resume visitors
 * Used to track visitors coming from resume links in Vercel Analytics
 */
const ResumeRedirect = () => {
  const navigate = useNavigate();
  const { authenticate } = usePDFAuth();

  useEffect(() => {
    // Automatically authenticate PDF access for resume visitors
    authenticate();
    
    // Track the /me page view first (Vercel Analytics will capture this)
    // Then redirect to home page after a brief moment
    const timer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 100);

    return () => clearTimeout(timer);
  }, [navigate, authenticate]);

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      backgroundColor: "#f5f5f5"
    }}>
      <div style={{ textAlign: "center" }}>
        <h2>Redirecting...</h2>
        <p>Please wait while we redirect you to the portfolio.</p>
      </div>
    </div>
  );
};

export default ResumeRedirect;
